export default __webpack_public_path__ + "static/media/vera-glass-tiles.1f59e627.svg";